import { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { BossWall } from './components/duel/BossWall'
import { DuelHome } from './components/duel/DuelHome'
import { DuelRoom } from './components/duel/DuelRoom'
import { C4, XOX } from './components/duel/defs'
import { Layout } from './components/Layout'
import { CyclesRoom } from './cycles/CyclesRoom'
import { RaceRoom } from './ice/RaceRoom'
import { SoloGame } from './ice/SoloGame'
import { CyclesHome } from './pages/CyclesHome'
import { DungeonHome } from './pages/DungeonHome'
import { DungeonRun } from './pages/DungeonRun'
import { GamePicker } from './pages/GamePicker'
import { IceHome } from './pages/IceHome'
import { Leaderboard } from './pages/Leaderboard'
import { Profile } from './pages/Profile'
import { useSession } from './store/session'

export function App() {
  const load = useSession((s) => s.load)
  useEffect(() => {
    void load()
  }, [load])

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<GamePicker />} />
        <Route path="xox" element={<DuelHome def={XOX} />} />
        <Route path="xox/wall" element={<BossWall def={XOX} />} />
        <Route path="r/:code" element={<DuelRoom def={XOX} />} />
        <Route path="c4" element={<DuelHome def={C4} />} />
        <Route path="c4/wall" element={<BossWall def={C4} />} />
        <Route path="c4/r/:code" element={<DuelRoom def={C4} />} />
        <Route path="ice" element={<IceHome />} />
        <Route path="ice/play/:levelId" element={<SoloGame />} />
        <Route path="ice/r/:code" element={<RaceRoom />} />
        <Route path="cycles" element={<CyclesHome />} />
        <Route path="cycles/r/:code" element={<CyclesRoom />} />
        <Route path="dungeon" element={<DungeonHome />} />
        <Route path="dungeon/run/:id" element={<DungeonRun />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="me" element={<Profile />} />
        <Route path="*" element={<GamePicker />} />
      </Route>
    </Routes>
  )
}
